/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store/index'
import { UPDATE_ACTIVATED_ELSEWHERE } from './store/mutationsTypes'
import { consumeInitiatedUpdate, loadPage } from './utils/appUpdate'

// How often an open app asks the server for a new service worker.
const UPDATE_INTERVAL_MS = 60 * 60 * 1000
const UPDATE_THROTTLE_MS = 60 * 1000

if (process.env.NODE_ENV === 'production') {
  let registration = null
  let lastUpdateCheck = 0

  const checkForUpdate = () => {
    if (!registration || navigator.onLine === false) return
    const now = Date.now()
    if (now - lastUpdateCheck < UPDATE_THROTTLE_MS) return
    lastUpdateCheck = now
    // Failures (offline, server down) don't matter: the next trigger retries.
    try { registration.update().catch(() => {}) } catch (e) { /* ignore */ }
  }

  // register-service-worker only hooks onupdatefound when no worker was
  // waiting at page load, so a second deploy in the same session would go
  // unnoticed. This listener covers both cases.
  const watchForUpdates = (reg) => {
    reg.addEventListener('updatefound', () => {
      const installing = reg.installing
      if (!installing) return
      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          store.commit('siteNewContent', reg)
        }
      })
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (reg) {
      console.log('Service worker has been registered.')
      registration = reg
      watchForUpdates(reg)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (reg) {
      // The new worker stays waiting until a safe moment (src/utils/appUpdate.js).
      console.log('New content is available; it is applied at the next safe moment.')
      store.commit('siteNewContent', reg)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
  if ('serviceWorker' in navigator) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') checkForUpdate()
    })
    window.addEventListener('online', checkForUpdate)
    setInterval(checkForUpdate, UPDATE_INTERVAL_MS)

    let reloading = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      const target = consumeInitiatedUpdate()
      if (target) {
        // This tab activated the new worker at a safe moment: load the new
        // build right away, the old build's files are gone from the cache.
        if (reloading) return
        reloading = true
        loadPage(target)
        return
      }
      // Another tab activated it. This page now runs the old build without
      // its files: reload at the next safe moment (appUpdate.js); a missing
      // chunk meanwhile is recovered there too.
      store.commit(UPDATE_ACTIVATED_ELSEWHERE, true)
    })
  }
}
